import { Row, Col } from 'react-bootstrap'

import styles from './BlockchainEra.module.scss'

export default function BlockchainEra() {
    return (
        <section className={styles.BlockchainEra}>
            <h2>
                The <span className="text-green">Blockchain</span> era is here
            </h2>
            <hr className={styles.hr} />
            <Row className="mb-5 mb-lg-6">
                <Col lg={6}>
                    <p>
                        Blockchain technology is just entering its prime and has already unlocked remarkable business
                        value: 93% of global executives believe that blockchain unlocks significant new revenue
                        potential, and 83% report that blockchain initiatives are already underway at their
                        organization.
                    </p>
                </Col>
                <Col lg={6}>
                    <p>
                        We take an active role in your software development process. Our consulting services educate,
                        explore and unlock every potential use case for the Casper Blockchain - from data security to
                        automation, smart contracts to IoT, and more.
                    </p>
                </Col>
            </Row>
            <Row>
                <Col className="mb-lg-0" md={5} lg={4}>
                    <h2 className={styles.h1}>
                        <span className="text-green"> 93 %</span>
                    </h2>
                    <p>of global executives believe that blockchain unlocks significant new revenue potential.</p>
                </Col>
                <Col className="d-flex justify-content-center" md={2} lg={4}>
                    <div className={styles.vl}></div>
                </Col>
                <Col md={5} lg={4}>
                    <h2 className={styles.h1}>
                        <span className="text-purple"> 83 %</span>
                    </h2>
                    <p>report that blockchain initiatives are already underway at their organization.</p>
                </Col>
            </Row>
        </section>
    )
}
